var map = {
	"./pexels-cinco.jpg": 268,
	"./pexels-cuatro.jpg": 328,
	"./pexels-dos.jpg": 178,
	"./pexels-seis.jpg": 382,
	"./pexels-siete.jpg": 280,
	"./pexels-tres.jpg": 708,
	"./pexels-uno.jpg": 436
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 641;